import { FC } from 'react'

type Props = {
  children: React.ReactNode
}

export const FlowCardCopy: FC<Props> = ({ children }) => (
  <div className="leading-tight mb-6 mt-6" style={{ fontSize: '0.9375rem' }}>
    {children}
  </div>
)
